import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Time is short whey you're old",
  "description": "",
  "published": "2009-04-17T00:00:00.000Z",
  "redirect_from": ["/blog/time-is-short-whey-youre-old/swizec/493"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Lestat_IWTV.jpg"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/en/thumb/6/67/Lestat_IWTV.jpg/202px-Lestat_IWTV.jpg",
              "alt": "Tom Cruise as Lestat in the 1994 film Intervie...",
              "title": "Tom Cruise as Lestat in the 1994 film Intervie..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Lestat_IWTV.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`My god I haven't blogged in a long time, have I been THAT busy? Are two weeks seriously this short when you're old? Shorter? But at least I'm having a bit of a good time, which I'm sure is more than many people can say.`}</p>
    <p>{`To be honest, I've been feeling a dash uninspired writing-wise ever since my dear Merrick died more than a week ago. Her graphics card went bezerk and there was nothing I could do. Wanted to replace the broken thing myself just so it'd be over with quickly, but alas, portable Macs don't use a graphics card per se, but a graphics chip and some memory right on the motherboard.`}</p>
    <p>{`This makes me sad.`}</p>
    <p>{`What's worse is that Merrick was my happy fun times computer so most of my passing entertainment like, say, RSS readers and whatnot, are there. Sure, there's a backup, but it's just not the same, not the same at all. I can't well read RSS feeds and blogs on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lestat_de_Lioncourt",
        "title": "Lestat de Lioncourt"
      }}>{`Lestat`}</a>{` the big fancy desktop computer. Just feels wrong! He's for work and fancy graphic effects and HD video and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/MSN",
        "title": "MSN"
      }}>{`MSN`}</a>{` and dust collecting.`}</p>
    <p>{`And so, without his trusty entertainment and constant twitter stream, our hapless hero is feeling old and betrayed and with the latest intelectual property debacle just a little bit raped and abusde. His answer? Fuck it.`}</p>
    <p>{`I'm investing a large portion of my savings in gold by the way, not looking for profits, just looking for retained `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Purchasing_power",
        "title": "Purchasing power"
      }}>{`buying power`}</a>{` and that's what gold seems to excel at. The gold broker I met with today also felt quite awesome and gave me a good gut feeling about the whole thing so I'm rather psyched about this.`}</p>
    <p>{`Gooooold.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/2631de0c-386d-4b3c-a178-7fe90bccaede/",
        "title": "Zemified by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=2631de0c-386d-4b3c-a178-7fe90bccaede",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      